import { createContext, useContext, useState, useEffect } from "react";
import { api } from "./apiClient";

const AppCtx = createContext();
export const useApp = () => useContext(AppCtx);

export const MONTHS = [
  { v: 1, n: "January" }, { v: 2, n: "February" }, { v: 3, n: "March" },
  { v: 4, n: "April" }, { v: 5, n: "May" }, { v: 6, n: "June" },
  { v: 7, n: "July" }, { v: 8, n: "August" }, { v: 9, n: "September" },
  { v: 10, n: "October" }, { v: 11, n: "November" }, { v: 12, n: "December" },
];

const ROLE_LABEL = { super_admin: "Super Admin", manager: "Manager", hr: "HR", employee: "Employee" };

function derivePermissions(role) {
  const isAdmin = role === "super_admin";
  const isManager = role === "manager";
  return {
    manageEmployees: isAdmin,
    editKra: isAdmin,
    assignTasks: isAdmin || isManager,
    updateTasks: role === "employee" || isAdmin || isManager,
    reviewEmployees: isAdmin || isManager,
    lockReviews: isAdmin || isManager,
    reopenReviews: isAdmin,
    overrideIncrement: isAdmin,
    settings: isAdmin,
    seeSalary: isAdmin || role === "hr",
    viewTeam: isAdmin || isManager || role === "hr",
    export: role !== "employee",
  };
}

export function AppProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=logged out
  const [theme, setTheme] = useState(localStorage.getItem("kra_theme") || "dark");
  const [month, setMonth] = useState(10);
  const [year, setYear] = useState(2026);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("kra_theme", theme);
  }, [theme]);

  useEffect(() => {
    const token = localStorage.getItem("kra_token");
    if (!token) { setUser(null); return; }
    api.me().then(setUser).catch(() => { localStorage.removeItem("kra_token"); setUser(null); });
  }, []);

  const login = async (email, password) => {
    const data = await api.login(email, password);
    localStorage.setItem("kra_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = () => { localStorage.removeItem("kra_token"); setUser(null); };

  const role = user?.role;
  const can = derivePermissions(role);
  const isEmployee = role === "employee";
  const selfEmployeeId = user?.employee_id;

  return (
    <AppCtx.Provider value={{
      user, login, logout, role, roleLabel: ROLE_LABEL[role], can, isEmployee, selfEmployeeId,
      theme, setTheme, month, setMonth, year, setYear,
    }}>
      {children}
    </AppCtx.Provider>
  );
}
